import { useRouter, useSearchParams } from 'next/navigation'

export const useToggleMapView = () => {
  const router = useRouter()
  const searchParams = useSearchParams()

  const toggleMapView = (mapView: boolean) => {
    // Create a new URLSearchParams instance to modify
    const params = new URLSearchParams(searchParams?.toString() ?? '')

    if (mapView) {
      params.delete('showMap')
    } else {
      params.set('showMap', 'true')
    }

    // Create the new URL and navigate to it
    const newUrl = `${window.location.pathname}?${params.toString()}`
    router.push(newUrl)
  }

  return toggleMapView
}
